import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

export const getAppInfo = async (): Promise<{ version: string; name: string; id: string; platform: string }> => {
  if (Capacitor.isNativePlatform()) {
    const appInfo = await App.getInfo();

    return {
      version: appInfo.version,
      name: appInfo.name,
      id: appInfo.id,
      platform: Capacitor.getPlatform(),
    };
  }

  return {
    version: import.meta.env.VITE_APP_VERSION || import.meta.env.VITE_APP_PACKAGE_VERSION || '0.0.1',
    name: window.location.hostname,
    id: window.location.hostname,
    platform: 'web',
  };
};
